/* VitaFresh Karussell für Portal-Seiten (CSS: .vfp-karussell in assets/vf-portal.css.liquid).
   Grundlage ist eine native Scroll-Spur mit scroll-snap: Wischen, Trackpad und Pfeiltasten (Spur fokussiert) gehen ohne JS.
   Dieses Skript ergänzt nur die Pfeil-Knöpfe (eine Seite vor/zurück) und sperrt sie am Anfang/Ende.
   Mehrfach eingebunden (mehrere Sections)? Jedes Karussell wird genau einmal eingerichtet (data-vfp-karussell="bereit").
   seitenSchritt(), ziel() und ränder() sind rein und in Node testbar: node --test tests/vfp-karussell.test.js */
(function (root) {
  "use strict";

  var TOLERANZ_PX = 2; /* Subpixel-Rundung beim Scrollen: so viel Abstand gilt noch als «am Rand» */

  /* Wie weit ein Pfeil scrollt: so viele ganze Karten, wie sichtbar sind (mindestens eine). */
  function seitenSchritt(spurBreite, kartenBreite, abstand) {
    var feld = kartenBreite + abstand;
    if (!(feld > 0) || !(spurBreite > 0)) return 0;
    var ganze = Math.max(1, Math.floor((spurBreite + abstand + TOLERANZ_PX) / feld));
    return ganze * feld;
  }

  /* Ziel-Position für richtung -1/1, begrenzt auf 0 … max. */
  function ziel(scrollLinks, schritt, richtung, max) {
    var neu = scrollLinks + richtung * schritt;
    return Math.min(Math.max(0, neu), Math.max(0, max));
  }

  /* Steht die Spur am Anfang, am Ende oder passt alles hinein? */
  function raender(scrollLinks, scrollBreite, sichtBreite) {
    var max = scrollBreite - sichtBreite;
    return {
      passt: max <= TOLERANZ_PX,
      anfang: scrollLinks <= TOLERANZ_PX,
      ende: scrollLinks >= max - TOLERANZ_PX
    };
  }

  function einrichten(el) {
    if (el.getAttribute("data-vfp-karussell") === "bereit") return;
    var spur = el.querySelector(".vfp-karussell__spur");
    var zurueck = el.querySelector('.vfp-karussell__pfeil[data-richtung="-1"]');
    var weiter = el.querySelector('.vfp-karussell__pfeil[data-richtung="1"]');
    if (!spur || !zurueck || !weiter) return; /* ohne Pfeile bleibt die reine Wisch-Spur */
    el.setAttribute("data-vfp-karussell", "bereit");

    var geplant = false;
    function auffrischen() {
      geplant = false;
      var r = raender(spur.scrollLeft, spur.scrollWidth, spur.clientWidth);
      el.classList.toggle("vfp-karussell--passt", r.passt);
      zurueck.disabled = r.passt || r.anfang;
      weiter.disabled = r.passt || r.ende;
    }
    function planen() {
      if (geplant) return;
      geplant = true;
      root.requestAnimationFrame(auffrischen);
    }
    function blaettern(richtung) {
      var karte = spur.querySelector(".vfp-karussell__karte");
      if (!karte) return;
      var stil = root.getComputedStyle(spur);
      var abstand = parseFloat(stil.columnGap || stil.gap) || 0;
      var innen = spur.clientWidth - (parseFloat(stil.paddingLeft) || 0) - (parseFloat(stil.paddingRight) || 0);
      var schritt = seitenSchritt(innen, karte.getBoundingClientRect().width, abstand);
      spur.scrollTo({ left: ziel(spur.scrollLeft, schritt, richtung, spur.scrollWidth - spur.clientWidth) });
    }

    zurueck.addEventListener("click", function () { blaettern(-1); });
    weiter.addEventListener("click", function () { blaettern(1); });
    spur.addEventListener("scroll", planen, { passive: true });
    if (root.ResizeObserver) new root.ResizeObserver(planen).observe(spur);
    el.classList.add("vfp-karussell--js");
    auffrischen();
  }

  function start() {
    var alle = root.document.querySelectorAll("[data-vfp-karussell]");
    for (var i = 0; i < alle.length; i++) einrichten(alle[i]);
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = { seitenSchritt: seitenSchritt, ziel: ziel, raender: raender };
  } else if (root.document && !root.vfpKarussellGeladen) {
    /* Mehrfach eingebunden (je Section ein <script>)? Nur der erste Lauf registriert die Listener. */
    root.vfpKarussellGeladen = true;
    if (root.document.readyState === "loading") root.document.addEventListener("DOMContentLoaded", start); else start();
    /* Theme-Editor: neu geladene Section einrichten. */
    root.document.addEventListener("shopify:section:load", start);
  }
})(typeof window !== "undefined" ? window : globalThis);
